import dispatcher from "../dispatcher"
import * as api from "../api"
import * as utils from "../helpers/utils"
import * as firebaseActions from "./FirebaseActions"
import AppStateStore from "../stores/AppStateStore"

export async function importPunchData(csvFileData: string[][]) {
    const asyncSessionId = utils.guid()
    setTimeout(() =>
        dispatcher.dispatch({
            type: "UPDATE_ASYNC_SESSION_ID",
            data: asyncSessionId
        })
        , 0)

    let result
    try {
        result = await api.importPunchData(csvFileData, asyncSessionId)
    }
    catch (e) {
        e.response.data.message &&
            AppStateStore.setProgressSnackbarContent(e.response.data.message)
    }
    finally {
        firebaseActions.clearAsyncSessionId()
    }

    return result.data
}

export async function importExpenseTimeData(csvFileData: string[][]) {
    const asyncSessionId = utils.guid()
    setTimeout(() =>
        dispatcher.dispatch({
            type: "UPDATE_ASYNC_SESSION_ID",
            data: asyncSessionId
        })
        , 0)

    let result
    try {
        result = await api.importExpenseTimeData(csvFileData, asyncSessionId)
    }
    catch (e) {
        e.response.data.message &&
            AppStateStore.setProgressSnackbarContent(e.response.data.message)
    }
    finally {
        firebaseActions.clearAsyncSessionId()
    }

    return result.data
}

export async function importExpenseAmountData(csvFileData: string[][]) {
    const asyncSessionId = utils.guid()
    setTimeout(() =>
        dispatcher.dispatch({
            type: "UPDATE_ASYNC_SESSION_ID",
            data: asyncSessionId
        })
        , 0)

    let result
    try {
        result = await api.importExpenseAmountData(csvFileData, asyncSessionId)
    }
    catch (e) {
        e.response.data.message &&
            AppStateStore.setProgressSnackbarContent(e.response.data.message)
    }
    finally {
        firebaseActions.clearAsyncSessionId()
    }

    return result.data
}

export async function importEmployeesData(csvFile: File) {
    const asyncSessionId = utils.guid()
    setTimeout(() =>
        dispatcher.dispatch({
            type: "UPDATE_ASYNC_SESSION_ID",
            data: asyncSessionId
        })
        , 0)
    let formData = new FormData()
    formData.append("File", csvFile, csvFile.name)
    formData.append("AsyncSessionId", asyncSessionId)

    let result
    try {
        result = await api.importEmployeesData(formData)
    }
    catch (e) {
        e.response.data.message &&
            AppStateStore.setProgressSnackbarContent(e.response.data.message)
    }
    finally {
        firebaseActions.clearAsyncSessionId()
    }

    return result.data
}

export async function importJobsData(csvFile: File) {
    const asyncSessionId = utils.guid()
    setTimeout(() =>
        dispatcher.dispatch({
            type: "UPDATE_ASYNC_SESSION_ID",
            data: asyncSessionId
        })
        , 0)
    let formData = new FormData()
    formData.append("File", csvFile, csvFile.name)
    formData.append("AsyncSessionId", asyncSessionId)

    let result
    try {
        result = result = await api.importJobData(formData)
    }
    catch (e) {
        e.response.data.message &&
            AppStateStore.setProgressSnackbarContent(e.response.data.message)
    }
    finally {
        firebaseActions.clearAsyncSessionId()
    }
    return result.data
}

export async function importScheduleData(csvFile: File, importAsPostedSchedule: boolean) {
    const asyncSessionId = utils.guid()
    setTimeout(() =>
        dispatcher.dispatch({
            type: "UPDATE_ASYNC_SESSION_ID",
            data: asyncSessionId
        })
        , 0)
    let formData = new FormData()
    formData.append("File", csvFile, csvFile.name)
    formData.append("AsyncSessionId", asyncSessionId)

    let result
    try {
        result = result = await api.importScheduleData(formData, importAsPostedSchedule)
    }
    catch (e) {
        e.response.data.message &&
            AppStateStore.setProgressSnackbarContent(e.response.data.message)
    }
    finally {
        firebaseActions.clearAsyncSessionId()
    }
    return result.data
}